export default __webpack_public_path__ + "static/media/180.0088747a.svg";